import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { useEffect } from 'react';
import { useRolesTableContext } from './RolesTableContext';

export const DeleteRolesDialog = () => {
  const {
    setOpenConfirmDialog,
    openConfirmDialog,
    selectedDeleteItems,
    setSelectedDeleteItems,
    selectedRow,
    deleteRoles,
  } = useRolesTableContext();

  useEffect(() => {
    if (selectedRow !== undefined && openConfirmDialog)
      setSelectedDeleteItems([selectedRow]);
  }, [selectedRow, setSelectedDeleteItems, openConfirmDialog]);

  return (
    <ConfirmDialog
      title="Remove permission"
      description={`Are you sure you want to remove ${selectedDeleteItems.length} assignments from this role`}
      onConfirm={() => {
        deleteRoles(selectedDeleteItems.map(i => i.id));
        setOpenConfirmDialog(false);
        setSelectedDeleteItems([]);
      }}
      open={openConfirmDialog}
      onClose={() => {
        setOpenConfirmDialog(false);
        setSelectedDeleteItems([]);
      }}
      confirmButtonText="Remove"
    />
  );
};
